import * as ToggleGroup from '@radix-ui/react-toggle-group';
import { Box, Typography } from '@mui/material';

import { examNames, type ExamName } from '../examTasks/examTaskTypes';
import { useExamName } from './examName';

export function ExamNameToggle() {
    const { examName, setExamName } = useExamName();

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
            <Typography
                variant="body2"
                sx={{
                    fontSize: 11,
                    fontWeight: 700,
                    letterSpacing: '0.04em',
                    textTransform: 'uppercase',
                    color: 'inherit',
                    opacity: 0.8,
                }}
            >
                Exam
            </Typography>
            <ToggleGroup.Root
                value={examName}
                type="single"
                className="exam-name-toggle"
                onValueChange={(value) => {
                    if (!value) return;
                    setExamName(value as ExamName);
                }}
            >
                {examNames.map((name) => (
                    <ToggleGroup.Item
                        key={name}
                        value={name}
                        className="exam-name-toggle__item"
                        aria-label={`Show ${name} exam tasks`}
                    >
                        {name}
                    </ToggleGroup.Item>
                ))}
            </ToggleGroup.Root>
        </Box>
    );
}